import { FocusEventHandler } from "react";

import CustomInput from "./CustomInput";

type TextareaInputProps = {
  value?: string | null;
  placeholder?: string;
  onChange: any;
  onBlur?: FocusEventHandler<HTMLElement>;
  label?: string;
  id?: string;
  rows?: number;
  cols?: number;
  name?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
};

const TextareaInput = (props: TextareaInputProps) => {
  const {
    disabled,
    value,
    placeholder,
    onChange,
    onBlur,
    label,
    id,
    name,
    rows,
    cols,
    error,
    required,
  } = props;
  return (
    <CustomInput id={id} label={label} error={error}>
      <textarea
        value={value || ""}
        placeholder={placeholder || ""}
        id={id}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        cols={cols}
        required={required}
      />
    </CustomInput>
  );
};

export default TextareaInput;
